import script from "./WorkflowModulSimple.js?vue&type=script&lang=js"
export * from "./WorkflowModulSimple.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__